module.exports = __webpack_public_path__ + "img/progress_007.9bf6c800.png";